import { Field } from "@fluentui/react-components";
import { DatePicker } from '@fluentui/react-datepicker-compat';

// own functions
import * as ownFunctions from './DateTimeInputfunctions';

// own styles
import './DateTimeInput.css';

//i18n
import { useTranslation } from 'react-i18next';


export interface IDateTimeInputProps {
  label: string | undefined;
  placeHolder?: string;
  selectedDate: Date | undefined;
  isSubmitted: boolean;
  isRequired: boolean;
  errorMessage: string | undefined;
  onSelectDate?: (date: Date | undefined) => void;
}

export const DateTimeInput = (props: IDateTimeInputProps) => {

  const { t } = useTranslation();

  const placeholder = props.placeHolder ?? t('DateTimeInput.placeholder');

  const onChangeSeletedDateFieldValue = (date: Date | null | undefined) => {
    if (props.onSelectDate) {
      const newDate = date ? new Date(date).setHours(0, 0, 0, 0) : undefined;
      props.onSelectDate(newDate ? new Date(newDate) : undefined);
    }
  };

  return (

    <Field label={props.label} required={props.isRequired}>
      <DatePicker
        //ref={datePickerRef}
        allowTextInput
        value={props.selectedDate}
        onSelectDate={onChangeSeletedDateFieldValue}
        formatDate={ownFunctions.onFormatDate}
        parseDateFromString={ownFunctions.parseDateFromString}
        placeholder={placeholder}
        className={(props.errorMessage && props.isSubmitted) ? 'error' : ''}
      />
      {(props.errorMessage && props.isSubmitted) && (
        <small className="error">{props.errorMessage}</small>
      )}
    </Field>
  );
};
